import { user } from 'state/user';
import useCurrentSurfacePermissions from 'components/canvas/hooks/use-current-surface-permissions';
import useAuthorization, {
  AuthorizationActions,
} from 'routes/surface/hooks/use-authorization';
import { SubSurfaceNode, SurfaceNodeUnion } from 'graphql/types';

interface UseSurfacePermissions {
  isOwner: boolean;
  isSharedSurfaceReference: boolean;
}

export default function useSurfacePermissions(
  surface: SubSurfaceNode,
): UseSurfacePermissions & AuthorizationActions {
  const loggedUser = user();

  const actions = useAuthorization(surface);

  const { isOwner: isCurrentSurfaceOwner } = useCurrentSurfacePermissions();

  const isOwner = Boolean(
    loggedUser?.id && surface?.ownedBy && loggedUser?.id === surface?.ownedBy,
  );

  function isNodeOwner(node: SurfaceNodeUnion): boolean {
    return node.ownedBy === loggedUser?.id;
  }

  return {
    isOwner,
    isSharedSurfaceReference: Boolean(
      isCurrentSurfaceOwner &&
        isNodeOwner(surface as any) === false &&
        surface?.isReference,
    ),
    ...actions,
  };
}
